import { createApp } from 'vue'
import RelayList from './RelayList'

const el = '.kb-component--relay-list'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((RelayListDOM) => {
            const props = {
                guid: RelayListDOM.dataset.guid,
                skip: parseInt(RelayListDOM.dataset.skip) ?? 0,
                take: parseInt(RelayListDOM.dataset.take) ?? 10,
                hideNoResults: RelayListDOM.hasAttribute('hide-no-results')
            }
            const component = createApp(RelayList, props).use(Store)
            component.mount(RelayListDOM)
        })
    }
}
